import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager.js';
import Cliente from './Cliente.jsx';

let valueSearch, clientes, timmerOneSeg;

/**
 * Componente encargado de la búsqueda de clientes
 */
class Buscador extends Component {
    constructor(props) {
        super(props);
        this.buscarPorDni = this.buscarPorDni.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.seleccionarCliente = this.seleccionarCliente.bind(this);
        this.limpiarFiltro = this.limpiarFiltro.bind(this);
    }

    limpiarFiltro() {
        this.props.cambiarBusqueda("");
    }

    /**
     * 
     * @param {any} event
     */
    onChangeFactor(event) {
        clearTimeout(timmerOneSeg);

        let reNumeros = new RegExp("^[0-9]{0,}$");
        let value = event.target.value;
        let me = this;

        this.props.cambiarBusqueda(value);
    }
    /**
     * 
     * @param {any} event
     */
    onKeyPress(evt) {

        var theEvent = evt || window.event;
        var regex = /[0-9]|\./;
        let reNumero = new RegExp("^[0-9]{7,11}$");

        var char = theEvent.keyCode || theEvent.which;
        char = String.fromCharCode(char);

        if (!regex.test(char)) {
            theEvent.returnValue = false;
            if (theEvent.preventDefault) theEvent.preventDefault();
        }

        if (theEvent.charCode == 13) {
            if (!reNumero.test(this.props.data.valueSearch)) {
                theEvent.returnValue = false;
                if (theEvent.preventDefault) theEvent.preventDefault();
            } else {
                this.props.buscarPorDni(this.props.data.valueSearch, false);
            }
        }
    }

    /**
     * Función de búsqueda de documento
     */
    buscarPorDni() { 
        let reNumero = new RegExp("^[0-9]{7,11}$");
        if (reNumero.test(this.props.data.valueSearch)) {
            //--SE COMENTA ESTA LINEA. DESCOMENTAR A PARTIR DE LA ETAPA 3.
            //this.props.getScreenData(this.props.routeState, this.props.currentScope);
            this.props.buscarPorDni(this.props.data.valueSearch, false);
        }
    }

    seleccionarCliente(clienteSeleccionado) {

        const { valueSearch, programaSelccionado } = this.props.data;
        this.props.seleccionarCliente(clienteSeleccionado, valueSearch, programaSelccionado)
    }

    render() {

        let tocaEnter = false;
        let optionClientes = null;

        const { mostrarListaClietes
            , clientesEncontrados
            , valueSearch
            , errorBusqueda
            , clienteNoEncontrado } = this.props.data;
           
        let titulo = this.props.currentScope && this.props.currentScope.ProgramCode == "CLIENTES" ? "Gestión de clientes" : "Gestión de cuentas";    

        if (clientesEncontrados.length > 0) {
            optionClientes = clientesEncontrados.map((cliente) => {
                return <Cliente
                    key={cliente.Id}
                    cliente={cliente}
                    seleccionarCliente={this.seleccionarCliente}
                    nroDocumento={valueSearch}
                />
            })
        }

        return (
            <div>
                <div className="row">
                    <div className="col-xs-12 div-client-search">
                        <h1 className="color-white">{titulo}</h1><br/>
                        <h4 className="color-white" style={{marginRight:'430px'}}>{"Identifique al cliente"}</h4>
                        <input type="text" maxLength="11" id="InputSeeker" name="InputSeeker" value={valueSearch} placeholder="Por favor ingrese el Número de Documento..." onChange={ (event) => this.onChangeFactor(event)} onKeyPress={this.onKeyPress} className="client-search-seeaker ClientSearch-searcClienteCuenta" required />

                        {this.props?.data?.valueSearch?.length > 0 ?
                        <div className="ClientSearch-btn-group-Borrar-Filtro">
                            <button id={"botonBorrarFiltroBuscarEntidad"} type="button" className="btn-tag ClientSearch-Filtros-Limpiar-Filtro"
                                onClick={this.limpiarFiltro}>
                                <span id={"botonBorrarXFiltroBuscarEntidad"} className="ti-close span-closable ClientSearch-span-Borrar-Filtro" />
                            </button>
                        </div>
                        :
                        null}

                        <button className="btn btn-cta client-search-button" type="button" id="buttonBusquedaCliente" onClick={() => { this.buscarPorDni() }} >
                            <span className="ti-search" aria-hidden="true"></span>
                        </button>
                        {mostrarListaClietes
                            ? <div className="div-vertical-scroll client-search-div-result"><ul className="client-search-ul">{optionClientes}</ul></div>
                            : null}
                        {clienteNoEncontrado
                            ? <div className="client-search-div-result padding-10">
                                <label className="client-search-label-primary">Ningún resultado encontrado</label>
                                <label className="client-search-label-secondary"></label>
                            </div>
                            : null}
                        {tocaEnter
                            ? <div className="client-search-div-result padding-10">
                                <label className="client-search-label-secondary">Complete el número de documento y presione ENTER.</label>
                            </div>
                            : null}
                    </div>
                </div>
            </div>
        );
    }
};

export default Buscador;